<div class="search-container">
  <div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
    <label class="searchbox" [class.dirty]="!!searchText">
      <input #searchInput [placeholder]="'searchBox.placeholder' | cxTranslate" autocomplete="off"
        aria-describedby="initialDescription" aria-controls="results"
        [attr.aria-label]="'searchBox.placeholder' | cxTranslate" (focus)="open()" [(ngModel)]="searchText"
        (click)="open(); onSearchInput($event)" (input)="
          search(searchText);
          showValidationError(searchText);
          onSearchInput($event);
          kbloader.FromSearchBox = false
        " (blur)="close($any($event)); closeValidationMsg(searchText); kbloader.FromSearchBox = true"
        (keydown.escape)="close($any($event)); clearRecentSearch()"
        (keydown.backSpace)="showValidationError(searchText)" (keydown)="onSearchInput($event)" (keydown.enter)="
          close($any($event));
          kbloader.FromSearchBox = true;
          launchSearchResult(searchInput.value);
          updateChosenWord(searchText);
          onSearchInput($event);
          onSearch($event);
          searchText='';
          clearRecentSearch()
        " (keydown.arrowup)="focusPreviousChild($any($event))" (keydown.arrowdown)="focusNextChild($any($event))" />
        <div role="presentation" class="search-icon">
        <cx-icon [type]="iconTypes.SEARCH" [class.disabled]="searchText.length < 3" (click)="
            searchText.length >= 3 && launchSearchResult(searchInput.value);
            close($any($event))
          "></cx-icon>
        </div>
        <div>
          <app-kb-vizseek></app-kb-vizseek>
        </div>
        <button [attr.aria-label]="'common.search' | cxTranslate" class="search" (click)="open()">
        <cx-icon [type]="iconTypes.SEARCH" [class.disabled]="searchText.length < 3" (click)="
            searchText.length >= 3 && launchSearchResult(searchInput.value);
            close($any($event))
          "></cx-icon>
        </button>
      </label>
    </div>
    @if (showValidation) {
      <div class="globle-search-validation" style="display: block">
        {{ 'common.globle_search_message' | cxTranslate }}
      </div>
    }
    @if (results$ | async; as result) {
      <div class="results" id="results"
        (click)="close($any($event)); clear(searchInput)" role="dialog">
        @if (result.message) {
          <div class="message" [innerHTML]="result.message"></div>
        }
        @if (result.products && closeResultBox) {
          <ul class="products"
            attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}" role="listbox">
            @for (product of result.products; track product) {
              <li>
                @if (product.pdpLinkFlag) {
<a role="option" [routerLink]="
          {
              cxRoute: 'product',
              params: product
            } | cxUrl
          " [class.has-media]="config.displayProductImages" (keydown.arrowup)="focusPreviousChild($any($event))"
                    (keydown.arrowdown)="focusNextChild($any($event))"
                    (keydown.enter)="close($any($event)); clear(searchInput)" (keydown.escape)="close($any($event))"
          (blur)="close($any($event))" (mousedown)="preventDefault($event)" (click)="
            dispatchProductEvent({
              freeText: searchText,
              productCode: product.code
            });
            onSearchPDPLink(product.code)
          ">
                    @if (config.displayProductImages) {
                      <cx-media [container]="product.images?.PRIMARY" format="thumbnail"
                      role="presentation"></cx-media>
                    }
                    <div class="code" [innerHTML]="product.code | searchHighlight : searchText"></div>
                    <div class="typenumber" [innerHTML]="product.typenumber | searchHighlight : searchText"></div>
                    <div class="name" [innerHTML]="product.nameHtml | searchHighlight : searchText"></div>
                  </a>
                } @else {
          <a role="option" [routerLink]="
          {
            cxRoute: 'search',
            params: { query: searchText }
          } | cxUrl
        
          " [class.has-media]="config.displayProductImages" (keydown.arrowup)="focusPreviousChild($any($event))"
                    (keydown.arrowdown)="focusNextChild($any($event))"
                    (keydown.enter)="close($any($event)); clear(searchInput)" (keydown.escape)="close($any($event))"
            (blur)="close($any($event))" (mousedown)="preventDefault($event)" (click)="
            dispatchProductEvent({
              freeText: searchText,
              productCode: product.code
            });
            onSearchPDPLink(product.code)
          ">
                    @if (config.displayProductImages) {
                      <cx-media [container]="product.images?.PRIMARY" format="thumbnail"
                      role="presentation"></cx-media>
                    }
                    <div class="code" [innerHTML]="product.code | searchHighlight : searchText"></div>
                    <div class="typenumber" [innerHTML]="product.typenumber | searchHighlight : searchText"></div>
                    <div class="name" [innerHTML]="product.nameHtml | searchHighlight : searchText"></div>
                  </a>
                }
              </li>
            }
          </ul>
        }
        <span id="initialDescription" class="cx-visually-hidden">
          {{ 'searchBox.initialDescription' | cxTranslate }}
        </span>
        @if (result.suggestions?.length || result.products?.length) {
          <div aria-live="assertive" class="cx-visually-hidden">
            {{ 'searchBox.suggestionsResult' | cxTranslate : { count: result.suggestions?.length } }}
            {{ 'searchBox.productsResult' | cxTranslate : { count: result.products?.length } }}
            {{ 'searchBox.initialDescription' | cxTranslate }}
          </div>
        }
      </div>
    }
    @if (recentSearches.length > 0) {
      <ul class="RecentSearch RecentSearchPopUP">
        <p class="RecentSearchText">{{ 'common.recent_search' | cxTranslate }}</p>
        @for (search of recentSearches; track search) {
          <p class="RecentSearch-item">
      <a [routerLink]="
          {
            cxRoute: 'search',
            params: { query: search.url }
          } | cxUrl
        " (click)="clearRecentSearch()" class="RecentSearch-anchor">{{ search.value }}</a>
          </p>
        }
      </ul>
    }
  </div>